import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { ImageUpload } from "@/components/site/ImageUpload";

const EMPTY = { titre: "", contenu: "", image: null, publie: true };

export const ArticleFormDialog = ({ open, onOpenChange, article, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF(article ? { titre: article.titre, contenu: article.contenu, image: article.image, publie: article.publie } : EMPTY); }, [open, article]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (article) await api.put(`/admin/articles/${article.id}`, f);
      else await api.post("/admin/articles", f);
      toast.success(article ? "Communiqué mis à jour" : "Communiqué publié");
      onSaved();
      onOpenChange(false);
    } catch (ex) {
      toast.error(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="article-form-dialog" aria-describedby={undefined} className="max-w-2xl max-h-[92vh] overflow-y-auto">
        <DialogHeader><DialogTitle className="font-display">{article ? "Modifier le communiqué" : "Nouveau communiqué"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-1.5"><Label>Titre *</Label><Input required data-testid="article-title-input" value={f.titre} onChange={(e) => setF({ ...f, titre: e.target.value })} /></div>
          <div className="space-y-1.5"><Label>Texte *</Label><Textarea required rows={8} data-testid="article-content-input" value={f.contenu} onChange={(e) => setF({ ...f, contenu: e.target.value })} /></div>
          <div className="space-y-1.5"><Label>Image (optionnelle)</Label><ImageUpload value={f.image} onChange={(v) => setF({ ...f, image: v })} testId="article-image-upload" /></div>
          <div className="flex items-center gap-3">
            <Switch id="publie" checked={f.publie} onCheckedChange={(v) => setF({ ...f, publie: v })} data-testid="article-publish-switch" />
            <Label htmlFor="publie">Visible publiquement</Label>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="article-form-cancel">Annuler</Button>
            <Button type="submit" disabled={busy} data-testid="article-form-submit">{busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Enregistrer</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
